import { render, staticRenderFns } from "./_QUESTIONNAIRE.vue?vue&type=template&id=39963189&"
import script from "./_QUESTIONNAIRE.vue?vue&type=script&lang=js&"
export * from "./_QUESTIONNAIRE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports